var static_components_config = {
  DOM_Component : {
    FaQComponent : FaQComponent
  },
  component_names: [
    'FaQComponent'
  ]
};
